import axios from "axios"
import { getRequestConfig } from "./auth"
import { ApiGateway } from "../config/config"

export const sendActivity = async (activity) => {
  const requestConfig = await getRequestConfig()
  const basePath = `${ApiGateway.user}/activity`

  try {
    await axios.post(basePath, activity, requestConfig)
  } catch (e) {
    console.error('Error on Activity: ', e.response.data.error)
  }
}

export const sendFileActivity = async (file, location, activity) => {
  const fileName = file?.fields?.LinkFilename
  const title = file?.fields?.Title
  const category = file?.fields?.QSEPortalResourceCategory

  const apd = {
    eventId: window.crypto.randomUUID(),
    clientTs: new Date(),
    eventType: 'file',
    app: 'web',
    event: {
      fileName,
      title,
      category: category ? category.replace(/category:/,'') : null,
      activity,
      ...location
    }
  }
  sendActivity(apd)
}